import styled from "@emotion/styled";
import {css} from "@mui/material";
import {OutUserType} from "components/Leaderboard/leaderboardContent/leaderboards/LeaderboardTable";

export const Cell = styled.div`
	font-weight: 400;
	font-size: 14px;
`;

export const Rank = styled(Cell)`
	//min-width: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 4px 8px 4px 4px;

	p {
		font-weight: 700;
		font-size: 16px;
	}
`;

export const DisplayName = styled(Cell)`
	margin-right: auto;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 8px;

	.delimiter {
		height: 20px;
		border-right: 1px solid #ffffff;
	}

	svg {
		width: 18px;
		height: auto;
	}

	p {
		font-weight: 400;
		font-size: 12px;

		&.vip {
			font-weight: 600;
			background: #222222;
			padding: 2px 6px;
			border-radius: 3px;
			display: inline;
			position: relative;
			top: 2px;
			font-size: 10px;
		}

		&:first-of-type {
			font-weight: 700;
			font-size: 14px;
		}
	}
`;

export const MyPlayer = styled(Cell)`
	text-align: right;
`;

export const Streak = styled(Cell)`
	text-align: right;
	min-width: 30px;
`;

export const BadgePosition = styled.div`
	position: absolute;
	left: 0;
	top: 2px;
	transform: translate(-50%, -50%);

	&.p_1,
	&.p_2,
	&.p_3 {
		color: #07090c;
	}

	@media (max-width: 880px) {
		transform: translate(-5px, -50%);
	}
`;

export const Body = styled.ol`
	overflow-y: auto;
	height: 100%;
`;

export const backgroundByPosition = (props: {position: number; isOwn: boolean}) => {
	const positionBG = {
		1: css`
			background: linear-gradient(90deg, #a87716 0%, #59400f 100%);
		`,
		2: css`
			background: linear-gradient(90deg, #5a697b 0%, #18293d 100%);
		`,
		3: css`
			background: linear-gradient(90deg, #665e4f 0%, #38342c 100%);
		`,
	}[props.position];

	if (positionBG) {
		return positionBG;
	}

	if (props.isOwn) {
		return css`
			background: linear-gradient(90deg, #62676e 0%, #575b62 100%);
		`;
	}

	return css`
		background: linear-gradient(90deg, #42474d 0%, #282f38 100%);
	`;
};

const getStickyStyle = (isTop: boolean) => {
	if (isTop) {
		return css`
			@keyframes toBottom {
				from {
					transform: translateY(-100%);
				}
				to {
					transform: translateY(0);
				}
			}
			transform: translateY(-100%);
			animation: toBottom 0.3s ease forwards;
			top: 49px;
			position: absolute;
			width: 100%;
			border-bottom: 2px solid gray;
			z-index: 10;
		`;
	}

	return css`
		@keyframes toTop {
			from {
				transform: translateY(100%);
			}
			to {
				transform: translateY(0);
			}
		}
		transform: translateY(100%);
		animation: toTop 0.3s ease forwards;
		top: auto;
		bottom: -2px;
		position: sticky;
		width: 100%;
		border-top: 2px solid gray;
		border-bottom: 2px solid #000;
		z-index: 4;
	`;
};
export const Row = styled.li<{
	position: number;
	isOwn: boolean;
	isSticky?: boolean;
	disabledClick?: boolean;
	withBorder: boolean;
	stickyType?: OutUserType;
}>`
	display: flex;
	gap: 10px;
	padding: 4px 20px;
	min-height: 52px;
	align-items: center;
	margin-top: 1px;
	position: relative;
	cursor: pointer;

	&:before {
		position: absolute;
		left: 0;
		top: 0;
		content: "";
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0;
		transition: opacity 0.3s ease;
	}

	&:hover {
		&:before {
			opacity: 0.1;
		}
	}

	${(props) =>
		props.isSticky &&
		css`
			${getStickyStyle(props.stickyType === OutUserType.TOP)};
			@media (max-width: 880px) {
				position: fixed;
				width: 100%;
			}
		`}
	${(props) =>
		props.disabledClick &&
		css`
			cursor: default;
			&:hover {
				&:before {
					opacity: 0;
				}
			}
		`}
	${(props) =>
		props.withBorder &&
		css`
			cursor: pointer;
		`}
	
	button {
		& > svg {
			color: #fff;
		}
	}

	${backgroundByPosition};

	@media (max-width: 480px) {
		padding: 4px 10px;
		gap: 6px;
	}
`;

export const StreakValue = styled(Streak)`
	font-weight: 700;
	font-size: 16px;
`;

export const Avatar = styled.div<{levelColor: string | null}>`
	position: relative;
	display: flex;

	& > img {
		width: 38px;
		height: 38px;
		border-radius: 10px;
		border: 2px solid ${(props) => props.levelColor || "#ffffff"};
	}
`;
